var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShield(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 17C7.11771 16.5333 5.5638 15.47 4.33828 13.81C3.11276 12.15 2.5 10.3067 2.5 8.28V3.4L9 1L15.5 3.4V8.28C15.5 10.3067 14.8872 12.15 13.6617 13.81C12.4362 15.47 10.8823 16.5333 9 17ZM9 15.32C10.3135 14.92 11.4104 14.13 12.2906 12.95C13.1708 11.77 13.6854 10.4533 13.8344 9H9V2.7L4.125 4.5V8.64C4.125 8.73333 4.13854 8.85333 4.16562 9H9V15.32Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShield);
export default __webpack_public_path__ + "static/media/shield.48d9e9e0e215e84ed12cb60712b16731.svg";
export { ForwardRef as ReactComponent };